/* global __STATIC_PATH__ */

import { DEFAULT_ELEMENT_ID } from 'constants/misc';
import { Element } from 'types';

// tslint:disable-next-line
const TRANSPARENT_PNG = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=';

const url = (id: Element['id']) => `${ __STATIC_PATH__ }/icons/${ id }.svg`;
const iconUrl = (id: Element['id']) => {
  if (id === DEFAULT_ELEMENT_ID) {
    return TRANSPARENT_PNG;
  }

  return url(id);
};

export default iconUrl;
